import { render } from "./BlogLanding.vue?vue&type=template&id=cb967b7c&scoped=true"
import script from "./BlogLanding.vue?vue&type=script&lang=js"
export * from "./BlogLanding.vue?vue&type=script&lang=js"

import "./BlogLanding.vue?vue&type=style&index=0&id=cb967b7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb967b7c"]])

export default __exports__